export const main = {
  name: "Md Rafi",
  occupation: "Founder of KS Devware",
  description: "I'm Frontend Software Engineer",
  image: "profilepic.jpg",
  bio: "I am Md Rafi. A young entrepreneur. With nearly 3 years of experience, I’m a Frontend developer, I have full  stack experience with a frontend focus. I'm currently working on KS-Devware institute. Worked as a professional Frontend developer. Learning Full-stack Web/App development.",
  email: "mdrafiprogrammer@gmail.com",
  phone: "+880 17032 50661",
  quote: "The universe is a pretty big place. If it's just us.",
  address: "Banasree, Dhaka, Bangladesh",
  website: "https://portfolio-mdrafi.vercel.app",
  resumedownload:
    "https://drive.google.com/file/d/1kplmYh-m84_tfb4FXA--QLZWB5Hci6v7/view?usp=share_link",
  social: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/programmerrafi",
      iconName: "logo-linkedin",
    },
    {
      name: "twitter",
      url: "https://twitter.com/programmerrafi",
      iconName: "logo-twitter",
    },
    {
      name: "facebook",
      url: "https://www.facebook.com/programmerrafi",
      iconName: "logo-facebook",
    },
    {
      name: "instagram",
      url: "https://www.instagram.com/programmerrafi",
      iconName: "logo-instagram",
    },
    {
      name: "github",
      url: "https://github.com/programmerrafi",
      iconName: "logo-github",
    },
  ],
};

export const about = {
  // bio: "I am a Fronted <br /><span class='text-primary'>developer</span> who cares<br /> about the mission",
  bio: "As a Frontend <br /> <span class='text-primary'>Software Engineer</span> I have full  stack experience with a frontend focus.",
  subtitle:
    "As a Frontend Software Engineer I have full stack experience with a frontend focus.",
  ido: `
  <p>WEB DEVELOPMENT</p>
  <p>APP DEVELOPMENT</p>
  <p>UI/UX DESIGN</p>
  <p>FRONT-END DEVELOPMENT</p>
  <p>BACK-END DEVELOPMENT</p>
  <p>FULL-STACK DEVELOPMENT</p>
  `,
  years: 3,
  image: "img/perfect-min.png",
  // "video": "https://www.youtube.com/watch?v=ghQd1PbzVaY",
  resumedownload:
    "https://drive.google.com/file/d/1kplmYh-m84_tfb4FXA--QLZWB5Hci6v7/view?usp=share_link",
};

export const works = [
  [
    {
      company: "",
      title: "Front-End Web Developer",
      image: "img/behance.png",
      years: "2019-2022",
      description:
        "• <b>HTML, CSS, JavaScript, React Js and others Tools</b> are the languages used for Front End development <br />• The structure, design, behavior, and content of everything seen on browser screens when websites, web applications, or mobile apps are opened up, is implemented by front End developers",
    },
    {
      company: "FN Softwares & KS-Devware institute",
      title: "Learning & Full-Stack Developer",
      image: "img/behance.png",
      years: "Feb 2019 - Present",
      description:
        "• Frontend web development is harder than backend because it changes more often, and the results take longer to achieve. However, it depends on my skillset. Both of them could be easier or harder than the other, depending on what i'm able to do and which tools when i use. ",
    },
  ],
  [
    {
      company: "KS-Devware",
      title: "Front-End Developer & UI/UX designer",
      image: "img/behance.png",
      years: "January 2022 - Present",
      description:
        "• Dedicated years of collaborative effort resulted in 30% increase in company revenue <br />• Responsible for testing applications <br />• Responsible for application code and UI/UX design",
    },
  ],
];

export const skills = {
  title:
    "My mission is to create an impact <span class='text-primary'>globally</span>",
  subtitle:
    "I will help you build your website and grow your business. I create clarifying strategy, beautiful website and identity design.",
  skills: [
    {
      title: "Skills: <span class='text-primary'>Ninja at</span>",
      // skills: ["JavaScript", "React JS", "React Native", "Node JS"],
      skills: [
        { title: "JavaScript", img: "img/skills/js.png", percent: "95%" },
        { title: "React JS", img: "img/skills/react.png", percent: "92%" },
        {
          title: "React Native",
          img: "img/skills/react-native.png",
          percent: "85%",
        },
        { title: "Next JS", img: "img/skills/next.png", percent: "90%" },
      ],
    },
    {
      title: "Skills: <span class='text-primary'>Front-end</span>",
      skills: [
        { title: "JavaScript", img: "img/skills/js.png", percent: "95%" },
        { title: "React JS", img: "img/skills/react.png", percent: "92%" },
        { title: "Next JS", img: "img/skills/next.png", percent: "90%" },
        { title: "HTML/CSS", img: "img/skills/html-css.png", percent: "98%" },
        { title: "SCSS", img: "img/skills/scss.png", percent: "90%" },
        { title: "UI Design", img: "img/skills/ui.png", percent: "96%" },
        { title: "Jquery", img: "img/skills/jquery.png", percent: "85%" },
        { title: "Redux", img: "img/skills/redux.png", percent: "90%" },
      ],
    },
    {
      title: "Skills: <span class='text-primary'>Back-end</span>",
      skills: [
        { title: "Node JS", img: "img/skills/node.png", percent: "80%" },
        { title: "Express JS", img: "img/skills/express.png", percent: "81%" },
        { title: "Rest API", img: "img/skills/rest.png", percent: "80%" },
      ],
    },
    {
      title: "Skills: <span class='text-primary'>Database</span>",
      skills: [
        { title: "MySQL", img: "img/skills/mysql.png", percent: "80%" },
        { title: "MongoDB", img: "img/skills/mongo.png", percent: "82%" },
        { title: "Firebase", img: "img/skills/firebase.png", percent: "90%" },
      ],
    },
    {
      title:
        "Skills: <span class='text-primary'>App development & Payment</span>",
      skills: [
        {
          title: "React Native",
          img: "img/skills/react-native.png",
          percent: "85%",
        },
        {
          title: "Stripe",
          img: "img/skills/stripe.png",
          percent: "80%",
        },
      ],
    },
    {
      title: "Skills: <span class='text-primary'>Cloud</span>",
      skills: [
        { title: "Google", img: "img/skills/google.png", percent: "80%" },
        { title: "AWS", img: "img/skills/aws.png", percent: "75%" },
        { title: "Heroku", img: "img/skills/heroku.png", percent: "75%" },
        { title: "Vercel", img: "img/skills/vercel.png", percent: "90%" },
      ],
    },
    {
      title: "Skills: <span class='text-primary'>Libraries</span>",
      skills: [
        {
          title: "Tailwind CSS",
          img: "img/skills/tailwind.png",
          percent: "90%",
        },
        { title: "Bootstrap", img: "img/skills/bootstarp.png", percent: "90%" },
        {
          title: "Material UI",
          img: "img/skills/material.png",
          percent: "80%",
        },
      ],
    },
    {
      title: "Skills: <span class='text-primary'>Others</span>",
      skills: [
        { title: "Figma", img: "img/skills/figma.png", percent: "80%" },
        {
          title: "Git, GitHub",
          img: "img/skills/git-github.png",
          percent: "80%",
        },
        { title: "WordPress", img: "img/skills/wordpress.png", percent: "70%" },
        {
          title: "Google Map",
          img: "img/skills/google-map.png",
          percent: "80%",
        },
        {
          title: "blockchain",
          img: "img/skills/blockchain.png",
          percent: "70%",
        },
        { title: "Mapbox", img: "img/skills/mapbox.png", percent: "70%" },
      ],
    },
  ],
};

export const projects = [
  {
    title: "Discord-Blockchain",
    category: "App",
    image: "discord.png",
    url: "https://rafi-discord.vercel.app",
  },
  {
    title: "CorporX website",
    category: "Website",
    image: "corporex.png",
    url: "https://corporx-react-website.vercel.app",
  },
  {
    title: "Social App",
    category: "App",
    image: "social-1.png",
    url: "https://social-app-pin.netlify.app",
  },
  {
    title: "Instagram-2.0",
    category: "App",
    image: "instagrem-2.png",
    url: "https://instagram-2-0-mu.vercel.app",
  },
  {
    title: "Chat App",
    category: "App",
    image: "chats1.png",
    url: "https://programmerrafi.github.io/chat-apps",
  },
  {
    title: "Educavo Website",
    category: "website",
    image: "educavo.png",
    url: "https://educavo-react.vercel.app",
  },
  {
    title: "React Clock",
    category: "App",
    image: "alarm.png",
    url: "https://reactclock-xi.vercel.app",
  },
  {
    title: "Travel Advisor",
    category: "App",
    image: "travel.png",
    url: "https://travel-advisor-google-app.netlify.app",
  },
  {
    title: "OpenSea Blockchain",
    category: "App",
    image: "opensea.png",
    url: "https://opensea-blockchain-by-rafi.vercel.app",
  },
  {
    title: "Snake Games",
    category: "App",
    image: "snake.png",
    url: "https://rafis-snake-games.vercel.app",
  },
  {
    title: "Book",
    category: "App",
    image: "book.png",
    url: "https://react-book-seven.vercel.app",
  },
  {
    title: "BreakOut Games",
    category: "App",
    image: "breakout.png",
    url: "https://brekout-mdrafi10.vercel.app",
  },
  {
    title: "Netflix",
    category: "App",
    image: "netflix.png",
    url: "https://react-netflix-clone-40-mdrafi10.vercel.app",
  },
  {
    title: "TikTok ",
    category: "App",
    image: "tiktok.png",
    url: "https://tiktok-typescript-with-next-js.vercel.app/",
  },
  {
    title: "Amazon",
    category: "App",
    image: "amazon.png",
    url: "https://amazon-clone-nextjs-4.netlify.app",
  },
  {
    title: "ChatGpt",
    category: "App",
    image: "chatGpt.png",
    url: "https://chat-gpt-next-js.netlify.app",
  },
];

export const partners = [
  {
    image: "1.png",
  },
  {
    image: "workslee.png",
  },
  {
    image: "gorelove.png",
  },
];

export const testimonials = [
  {
    text: "We are very content and happy wan all the work Md Rafi has done for us! Not only did he just what he had to do, comes up with suggestions and improvements of his owns and points out weaknesses which he in perfect communication is able to improve. Recommended! ",
    user: "Jason Sindram",
    company: "CTO at DP-Websolutions",
  },
  {
    text: "Superb. Great comms, understood the requirement, and delivered quickly. Multiple revisions allowed which were very helpful. I will work with him again.",
    user: "Bhavesh Patel",
    company: "CEO at Ganlaxgroup",
  },
];
